import { render, staticRenderFns } from "./PPPlayerDefault.vue?vue&type=template&id=8bab2eec&"
import script from "./PPPlayerDefault.vue?vue&type=script&lang=js&"
export * from "./PPPlayerDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../playmaker_app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports